module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/c521018f372c38b0f90575a2c03df0ff.png";